document.addEventListener('DOMContentLoaded', () => {

  const avpContainer = document.querySelector('.avpoptions-container__v2');

    const removeClass = () => {

    const avpContainer = document.querySelector('.avpoptions-container__v2');

    if(avpContainer){
      const images = document.querySelectorAll('.hover-img-hidden-mobile');

      if(images.length){
        images.forEach(image => image.classList.remove('hover-img-hidden-mobile'));

        clearInterval(myInterval);
      }
    }

    
  };

  const myInterval = setInterval(removeClass, 2000)




   
})


